var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 9.5,
  width: 16,
  height: 10.8,
  rx: 1.4,
  fill: "#2e4057"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 15.8,
  y: 10.8,
  width: 13.4,
  height: 8.2,
  fill: "#cfe3ee"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 21.4,
  y: 20.3,
  width: 2.2,
  height: 2.8,
  fill: "#2e4057"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 17.6,
  y: 22.6,
  width: 9.8,
  height: 1.6,
  rx: 0.8,
  fill: "#2e4057"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m12.3 21.6c-2.2-0.4-3.3-1.9-3.3-3.9 2.2 0.4 3.3 1.9 3.3 3.9z",
  fill: "#6aa66b"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m12.3 21.6c2.2-0.4 3.3-1.9 3.3-3.9-2.2 0.4-3.3 1.9-3.3 3.9z",
  fill: "#6aa66b"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m10.2 21.4h4.2l-0.7 2.8h-2.8z",
  fill: "#b3552f"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 24.2,
  width: 33,
  height: 3.2,
  rx: 1.5,
  fill: "#c8925a"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 8.6,
  y: 27.4,
  width: 2.7,
  height: 13,
  fill: "#8a6238"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 33.7,
  y: 27.4,
  width: 2.7,
  height: 13,
  fill: "#8a6238"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.5,
  cy: 10.5,
  r: 7,
  fill: "#3d7dd8"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 32.6,
  y: 8,
  width: 5.2,
  height: 1.5,
  rx: 0.7,
  fill: "#ffffff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m37.6 6.8 3 1.95-3 1.95z",
  fill: "#ffffff"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 35.2,
  y: 11.5,
  width: 5.2,
  height: 1.5,
  rx: 0.7,
  fill: "#ffffff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m35.4 10.3-3 1.95 3 1.95z",
  fill: "#ffffff"
});

function SvgDeskChangeRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskChangeRequest);
export default __webpack_public_path__ + "static/media/desk-change-request.9409dfb7f4879b99f074635a761a4cc3.svg";
export { ForwardRef as ReactComponent };